import { Component, OnInit, ChangeDetectionStrategy, ViewChild, EventEmitter, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { SystemService } from '../../../../services/system.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ProductService } from '../../../product/product.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { combineLatest, Observable, Subject, Subscription, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { map } from 'rxjs/operators';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { VmMachineService } from 'src/app/services/vm-machine.service';
import { ConfigService } from 'src/app/shared/config';
import { P } from '@angular/cdk/keycodes';
import { OfflineSyncService } from 'src/app/services/offline-sync.service';
import { ApplicationStateService } from 'src/app/shared/applicationState.service';

@Component({
  selector: 'app-stockcontroll',
  templateUrl: './stockcontroll.component.html',
  styleUrls: ['./stockcontroll.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class StockcontrollComponent implements OnInit, OnDestroy {

  siteId: string;
  systemId: string;
  fragment: string;
  user: User;
  product$;
  combObs$ = new Subject;
  saving = false;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  onDisbaleEdit: EventEmitter<any> = new EventEmitter<any>();

  // 'updatedOn', 'createdOn', 'createdBy', 'detail', 'status', 'action'
  // displayedColumns: string[] = ['name', 'maxLimit', 'threshold', 'quantity', 'fillStatus'];
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'name',
      name: 'Product',
      class: "mobile",
      maxLengthOnMobile: 15
    },
    {
      columnId: 'selection',
      name: 'Channel #',
      hideOnMobile: true,
      // align: 'center'
    },
    {
      columnId: 'index',
      name: 'index',
      // hideOnMobile: true,
      // align: 'center'
    },
    {
      columnId: 'quantity',
      name: 'Qty',
      // maxLengthOnMobile: 10,
      // align: 'right'
    },
    {
      columnId: 'disabledName',
      name: 'Disabled',
      hideOnMobile: true,
      listener: this.onDisbaleEdit,
      // align: 'right'
    },
    {
      columnId: 'performedAt',
      name: 'Updated',
      hideOnMobile: true,
      // align: 'right'
    },

    {
      columnId: 'maxLimit',
      name: 'Maximum limit',
      hideOnMobile: true,
      // align: 'right'
    }
  ]

  sortingArray = ['Product name', 'Product #', 'Channel #', 'Machine', 'Quantity', 'Diff.', 'Structural Qty', 'Maximum limit', 'Threshold', 'Fill status']


  dataSource$: Observable<MatTableDataSource<any>>;
  projects$: Observable<any>;
  // siteId: string;
  projects: MatTableDataSource<any>;
  haveFilter = false;
  isAdmin: boolean = false;
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: any; }[] = [];

  topbarActionButton: any[];
  onEdit: EventEmitter<ActionButtonEvent>;
  onAdd: EventEmitter<ActionButtonEvent>;
  onMinus: EventEmitter<ActionButtonEvent>;


  onUpdate: EventEmitter<any>;
  onUpdateSubscription: Subscription;
  onDeleteSubscription: Subscription;
  onEditSubscription: Subscription;
  onAddSubscription: Subscription;
  onMinusSubscription: Subscription;
  getStock$ = new Observable
  getStockSub = new Subscription
  getStockArray = new Array()

  stockUpdateArray = new Array()

  constructor(private route: ActivatedRoute,
    public dialog: MatDialog,
    private productService: ProductService,
    private sysService: SystemService,
    private vmService: VmMachineService,
    private notifierService: NotificationService,
    private config: ConfigService,
    public appState: ApplicationStateService,
    public offlineSync: OfflineSyncService,
    public auth: AuthService) {


    this.onAdd = new EventEmitter<ActionButtonEvent>();
    this.onMinus = new EventEmitter<ActionButtonEvent>();

    this.onUpdate = new EventEmitter<any>();
    // this.siteId = this.route.parent.snapshot.params['siteId'];

    this.rowActionButtons.push(
      { icon: 'add_circle', tooltip: 'Edit', eventEmitter: this.onAdd },
      { icon: 'remove_circle', tooltip: 'Edit', eventEmitter: this.onMinus })


    this.auth.getUser$().subscribe(userInfo => {
      this.isAdmin = userInfo['roles'].admin;
    });
    combineLatest(this.route.parent.params, this.route.params).subscribe(params => {

      this.siteId = params[0]['siteId']
      this.systemId = params[1]['systemId']
      this.getStock$ = this.sysService.getStockData$(this.siteId, this.systemId)
        .pipe(map(async array => {

          const stockRows = await Promise.all((array as any).map(async obj => {
            // console.log(obj['productId'])
            let product = await this.productService.getProductById(obj['productId']) // array[0].filter(t => t['id'] === obj['productId'])[0]
            if (!product) {
              return null;
            }

            let threshold = product ? product['threshold'] : 0;
            // console.log(JSON.stringify(obj))
            return {
              ...obj,
              quantity: obj.quantity.toString(),
              ...product as object,
              name: product['name'],
              disabled :  obj['disabled'] == true ? obj['disabled'] : false,
              disabledName : obj['disabled'] ? "Yes" : "No",
              maxLimit: product['maxLimit'],
              fillStatus: threshold >= obj['quantity'] ? 'Low' : 'Ok',
              diff: ((obj.maxLimit ? obj.maxLimit : product['maxLimit']) - obj.quantity).toString(),
              structuralQtyPerUnit: obj.structuralQtyPerUnit ? obj.structuralQtyPerUnit : 0,
              structuralQty: obj.structuralQtyPerUnit ? (obj.quantity * obj.structuralQtyPerUnit).toFixed(2) : obj.quantity.toFixed(2),
              index: obj.machineName + '  ' + (Number(obj.selection) + 1)
            }
          }))

          return stockRows.filter(row => row !== null);
        }))
      this.getStockSub = this.getStock$.subscribe(d => {

        (d as any).then(async da => {
          // let records = await this.sortArray(da)
          // console.log("da", JSON.stringify(records))
          this.getStockArray = da
          this.combObs$.next(da)
        })
      })
    })



  }


  ngOnInit() {

    if (this.offlineSync.hasPendingRequests()) {
      this.sysService.retryPendingUpdates();
    }

    this.onDisbaleEdit.subscribe(event => {
      console.log(event)
      event.disabled =   event.disabled == true ? !event.disabled : true;
      event.disabledName = event.disabled == true ? "Yes" : "No";
      event.modified = true;
      event.rowClass = 'modified-row';
      this.getStockArray[this.getStockArray.findIndex(stock => stock.uid == event.uid)] = event;
      this.combObs$.next([...this.getStockArray]);
    });


    this.onAddSubscription = this.onAdd.subscribe(event => {
      // if (id == event.eventData.uid) {
  
      if (Number(event.eventData['quantity']) >= Number(event.eventData['maxLimit'])) {
        this.notifierService.showNotification('error', `Maximum limit is ${event.eventData['maxLimit']}`);
      } else {
        event.eventData.quantity = Number(event.eventData.quantity) + 1
        event.eventData.newValue = Number(event.eventData.newValue) + 1
        event.eventData.modified = true;
        event.eventData.rowClass = 'modified-row';
        this.getStockArray[this.getStockArray.findIndex(stock => stock.uid == event.eventData.uid)] = event.eventData;
        this.combObs$.next([...this.getStockArray]);
      }

    });
    this.onMinusSubscription = this.onMinus.subscribe(event => {
      if (Number(event.eventData['quantity']) <= 0) {
        this.notifierService.showNotification('error', `Minimum limit is 0`);
      }
      else {
        event.eventData.quantity = Number(event.eventData.quantity) - 1
        event.eventData.newValue = Number(event.eventData.newValue) - 1
        event.eventData.modified = true;
        event.eventData.rowClass = 'modified-row';
        this.getStockArray[this.getStockArray.findIndex(stock => stock.uid == event.eventData.uid)] = event.eventData;
        this.combObs$.next([...this.getStockArray]);
      }
      
   
    });


  }



  async updateQuantity(result, value) {
    let obj = {

    };
    if (result) {

      // console.log(this.siteId, this.systemId, result, value)
      obj['newValue'] = Number(result.quantity) + value
      obj['quantity'] = Number(result.quantity) + value;
      // obj['quantity'] = Number(result.quantity);
      obj['productName'] = result.name;
      obj['productId'] = result.productId;
      obj['maxLimit'] = result.maxLimit
      obj['channelId'] = result.channelId

      obj['structuralQtyPerUnit'] = result.structuralQtyPerUnit
      if (Number(obj['quantity']) > Number(obj['maxLimit'])) {
        this.notifierService.showNotification('error', `Maximum limit is ${obj['maxLimit']}`);
      }
      else {
        let response = await this.sysService.updateQuantity(this.siteId, this.systemId, obj);
        if (response && response.success) {
          this.notifierService.hideAllNotifications();
          this.notifierService.showNotification('success', response.message);
          obj['quantity'] = Number(obj['quantity']);
        } else {
          this.notifierService.showNotification('error', response?.message || "Please try again");
        }
        // obj.newValue = 0;
      }
    }
  }

  sortArray(array) {
    return new Promise((res, rej) => {
      let temp = 0;
      for (let i = 0; i < array.length; i++) {
        for (let j = i; j < array.length; j++) {
          if (array[j]['selection'] < array[i]['selection']) {
            temp = array[j];
            array[j] = array[i];
            array[i] = temp;
          }
          if (array[j]['machineName'] < array[i]['machineName']) {
            temp = array[j];
            array[j] = array[i];
            array[i] = temp;

          }

        }
      }
      let count = 11
      array.forEach((element, index) => {
        if (count % 10 == 0) count++

        element.index = count
        count++
      });
   
      res(array);
    })

  }

  updateChannelMapping() {
    // event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Apply changes",
          message: " Are you sure to continue? ",
          class: ['warn-button', 'theme-button']
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.vmService.updateChannelMapping(this.siteId, this.systemId);
      this.sysService.addActionLog(this.siteId, this.systemId, {
        message: `Apply changes`,
      })
    });

  }

  ngOnDestroy(): void {
    this.getStockSub.unsubscribe()
  }


  async save() {

    this.saving = true;
    try {
      await this.sysService.updateStocks({ companyId: this.config.getCompanyId(), siteId: this.siteId, systemId: this.systemId, stockArry: this.getStockArray })
      this.getStockArray.forEach(item => {
        item.modified = false;
        item.rowClass = '';
      });
      this.combObs$.next([...this.getStockArray]);
      await this.sysService.addActionLog(this.siteId, this.systemId, {
        message: `Save inventory`,
      })
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
    }
  }

  async retryUpdates() {
    this.saving = true;
    await this.sysService.retryPendingUpdates();
    this.saving = false;
  }


}
